/* eslint-disable max-len */
import React from "react"
import { BodyText, InlineText, SubTitle } from "../../Typography/Typography"
import SmartLink from "../../layout/SmartLink/SmartLink"

const providerProfileClickEvent = () => ({
  name: "SEO Filtered Directory - Copy link to provider clicked",
  properties: {
    "Care Type": "care_home",
    "GEO Location": "Manchester",
    "Current URL":
      "https://www.caresourcer.com/s/providers/towns/manchester/care-home/",
  },
})

export default {
  summary: (
    <BodyText marginBottom>
      Choosing a care home for a loved one can be difficult, however with over
      140 care homes in Manchester, and 90 rated Good or Outstanding by the Care
      Quality Commission (CQC), there’s plenty to choose from. Here are a few of
      our top tips to help you narrow your options and find the right care home.
    </BodyText>
  ),
  content: [
    <SubTitle marginBottom bold>
      Location is key
    </SubTitle>,
    <BodyText marginBottom>
      When choosing a care home we find that most people want to stay close to
      home, in an area they know and love, however it is also important that
      friends and family are able to easily visit. Balancing these needs can
      sometimes be quite a challenge, however with over 140 care homes in
      Manchester you should be spoilt for choice. Manchester has excellent
      public transport, often with bus stops and railway stations within walking
      distance to care homes, and of course many of the homes offer parking
      facilities. It is our advice to speak to any care homes you are interested
      in to find out specific transport options near them.
    </BodyText>,
    <SubTitle marginBottom bold>
      Feeling at home
    </SubTitle>,
    <BodyText marginBottom>
      Once you have decided on an area, it is important to consider the
      facilities available at the care home, and think about what would help
      make your loved one feel settled and at home. Whilst most of the care
      homes in Manchester will allow you to move in furniture or to add personal
      touches to the residents room, you need to consider what your loved one
      enjoys doing with their days and find a home that can accommodate this.
    </BodyText>,
    <SubTitle marginBottom bold italic>
      Gardens and outdoor spaces
    </SubTitle>,
    <BodyText marginBottom>
      How important is outdoor space? Does your loved one like to look out at
      the wildlife in a garden or are they green fingered and like to help grow
      plants or vegetables? With over 100 of the care homes in Manchester
      offering garden space there will be something to suit. Whether that is{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-363198488/lightbowne-hall?care_type=care_home&clients_in_area=0&distance=5&location=Manchester&page=1&per_page=12&result_position=3&results_set=Search+Results+-+Card+Deck&sort_by=relevance"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Lightbowne Hall</InlineText>
      </SmartLink>{" "}
      which has lovely landscaped gardens to sit in and enjoy the sun, or the{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-123913080/mary-joseph-house?distance=4.43&lat=53.476931213283464&lng=-2.2407469256628265&location=Manchester&page=1&per_page=1000"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Mary & Joseph House</InlineText>
      </SmartLink>{" "}
      where they can sit and listen to football at Etihad Stadium and reminisce
      about the great games from when they were young, Manchester has something
      to meet everyone&apos;s needs.
    </BodyText>,
    <BodyText marginBottom bold italic>
      Pets welcome
    </BodyText>,
    <BodyText marginBottom>
      Does your loved one have a pet and is worried about leaving them when they
      move into a care home, or do they have allergies to pet hair? With over 70
      pet-friendly care homes in Manchester, it is recommended to understand the
      home’s pet policy in advance, as some allow pets to move in with their
      owner and others, like{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-126242409/wellington-lodge"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Wellington Lodge in Cheetham</InlineText>
      </SmartLink>
      , allow pets to visit on appointment.
    </BodyText>,
    <BodyText marginBottom bold italic>
      Activities and days out
    </BodyText>,
    <BodyText marginBottom>
      Finally take time to research the different facilities and activities that
      care homes in Manchester organise for their residents, to ensure your
      loved one will enjoy their time there. For example at the{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-1938268345/manorhey-care-centre"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Manorhey Care Centre</InlineText>
      </SmartLink>
      , just north of Trafford, they run frequent cooking, gardening and
      exercise classes.They also have several arts and crafts events each week,
      cinema evenings, food tasting experiences and live music, to name only
      some of the activities on offer. Our advice is to think about what makes
      your loved one happy and be sure to ask any potential care homes how they
      would help accommodate this.
    </BodyText>,
  ],
}
